import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import authService from '../services/authService';


const ProtectedAuth: FC = () => {
    const token = authService.getToken()

    return !token ? <Outlet /> : <Navigate to="/" />
}

export default ProtectedAuth